import React from "react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ShieldCheck, Award, CircleCheck } from "lucide-react";
export default function CompleteHvacMastery() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const certifications = [{
    name: "TECL licensed",
    logo: "https://humorous-shiner.10web.cloud/wp-content/uploads/2026/03/TECL-1.png?v=gzdcd9i5aqm",
    alt: "Texas Department of Licensing and Regulation Certified"
  }, {
    name: "Master Electrician",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603327/img/logo_epa_certification.png",
    alt: "Master Electrician Certified Professional"
  }];
  return <section data-section-id="4795" id="home-electrical-excellence" className="relative flex min-h-[600px] w-full items-center justify-center overflow-hidden bg-background py-20">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-white/30 z-10" />
        <div className="h-full w-full bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603327/img/commercial_hvac_complex_setup.png)] bg-cover bg-center bg-no-repeat" />
      </div>

      {}
      <div ref={ref} className={`container relative z-20 mx-auto px-4 text-center transition-all duration-1000 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
        <div className="mx-auto max-w-4xl">
          {}
          <div className="mb-6 flex justify-center">
            <Badge variant="outline" className="inline-flex items-center justify-center rounded-md border w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&]:hover:bg-accent [a&]:hover:text-accent-foreground border-primary/50 bg-primary/10 px-4 py-1 text-sm font-semibold uppercase tracking-wider backdrop-blur-sm !text-[hsl(224,64%,33%)] dark:aria-invalid:ring-destructive/40">FAMILY OWNED & OPERATED</Badge>
          </div>

          {}
          <h1 className="mb-12 font-sans text-4xl font-bold leading-tight tracking-tight text-secondary sm:text-5xl md:text-6xl lg:text-7xl">
            Home Electrical <span className="!text-[hsl(224,64%,33%)]">Excellence</span>{" "}
            in Richmond
          </h1>

          {}
          <div className="flex flex-col items-center justify-center gap-8">
            <p className="text-lg font-medium text-muted-foreground">Generator Install • Electrical Panel Replacement • Troubleshooting</p>
            
            <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
              {certifications.map((cert, i) => <div key={i} data-index={i} className="group relative flex h-20 w-32 items-center justify-center rounded-sm bg-white border border-border p-4 shadow-sm transition-all duration-300 hover:bg-muted hover:shadow-md">
                  <img src={cert.logo} alt={cert.alt} className="max-h-full max-w-full object-contain opacity-90 grayscale transition-all duration-300 group-hover:scale-110 group-hover:grayscale-0 group-hover:opacity-100" />
                  {}
                  <div className="absolute -bottom-8 left-1/2 w-max -translate-x-1/2 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                    <span className="text-xs font-mono font-medium text-secondary">
                      {cert.name}
                    </span>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}